import React, { KeyboardEvent } from 'react'
import { CheckIcon } from '@chakra-ui/icons'
import { Flex, Text } from '@chakra-ui/react'

import { focusElementById } from 'utils/events'
import { slugMask } from 'utils/masks'
import { Option } from 'types'

type Props = {
  index: number
  isSelected: boolean
  option: Option
  options: Array<Option>
  handleOnSelect: (option: Option) => void
}

const AutoCompleteItem = ({ isSelected, option, options, handleOnSelect, index }: Props) => {
  function handlePressArrowUp() {
    if (index > 0) focusElementById(slugMask(options[index - 1].label))
  }

  function handlePressArrowDown() {
    if (index < options.length - 1) focusElementById(slugMask(options[index + 1].label))
  }
  async function dispatchActionWhenPressSpaceEvent(event: KeyboardEvent<HTMLDivElement>) {
    if (event.code === 'Enter') handleOnSelect(option)
    if (event.code === 'ArrowUp') handlePressArrowUp()
    if (event.code === 'ArrowDown') handlePressArrowDown()
  }

  return (
    <Flex
      gap={2}
      p={2}
      tabIndex={0}
      id={slugMask(option.label)}
      align="center"
      justify="space-between"
      rounded="sm"
      cursor="pointer"
      outline="none"
      key={option.value}
      onClick={() => handleOnSelect(option)}
      onKeyUp={(event) => dispatchActionWhenPressSpaceEvent(event)}
      _hover={{ bg: 'lightPrimary', borderColor: 'primary' }}
      _focus={{ bg: 'lightPrimary', borderColor: 'primary' }}
    >
      <Text>{option.label}</Text>

      {isSelected && <CheckIcon boxSize={4} />}
    </Flex>
  )
}

export default AutoCompleteItem
